export default __webpack_public_path__ + "wheel-of-fortune.png";